import { OrderOperation, PageProps } from "../../components/types";
import FGInspection from '../../components/FGInspection'
import PageContainer from "../PageContainer";
import { DgtPdProductionOrder, Department } from "../../models";
import {
  getOrder,
  getActiveOperations,
} from "../../apis";

import {
  SearchField,
} from "@aws-amplify/ui-react";

import { useForm, SubmitHandler } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import { useContext, useState } from "react";
import OrderHeader from "../../components/OrderHeader";
import { getBrandLogoUrl } from "../../utilities/Image";

import UserContext from "../../contexts/UserContext";

import useFGInpsectionLog from "../../hooks/useFGInspectionLog";

interface Inputs {
  productionOrder: string
}

export default function FGInspectionPage({ title }: PageProps) {
  const { user } = useContext(UserContext);
  const currentUser: any = user;
  const currentDepartment : Department = currentUser.department;

  const [ showFgInspectForm, setShowFgInspectForm ] = useState<boolean>(false);
  const [ order, setOrder ] = useState<DgtPdProductionOrder>();
  const [ operations, setOperations ] = useState<OrderOperation[]>([]);
  const [ selectedOperation, setSelectedOperation ] = useState<OrderOperation>();
  const [ loading, setLoading ] = useState<boolean>(false);

  const [ fgInspectionLogs, mutate ] = useFGInpsectionLog({ 
    productionOrder: order!,
    workCenterId: selectedOperation?.actualWorkCenterId ? selectedOperation.actualWorkCenterId : selectedOperation?.workCenterId!,
    department: currentDepartment,
    machineCategory: selectedOperation?.machineCategory
  });
  
  const schema = yup.object({
    productionOrder: yup.string().required('กรอก pd order 8 หลัก').length(8, 'กรอก pd order 8 หลัก'),
  })

  const { 
    register, handleSubmit, formState: { errors }
  } = useForm<Inputs>({
    resolver: yupResolver(schema)
  })

  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    setLoading(true)
    const productionOrder = await getOrder(data.productionOrder);
    setOrder(productionOrder);
    const operations = await getActiveOperations(data.productionOrder);
    setOperations(operations.filter(op => op.isRequiredFGInspect));
    setLoading(false)
  }

  const brandLogoUrl = getBrandLogoUrl(order?.materialMrp || '')
  return (
    <PageContainer title={title} className="space-y-3 ">
      <form onSubmit={handleSubmit(onSubmit)}>
        <SearchField
          label="search"
          placeholder="พิมพ์ PD Order"
          disabled={loading}
          onClear={() => {
            setOrder(undefined)
            setOperations([])
            setSelectedOperation(undefined)
          }}
          {...register('productionOrder')}
        />
        {errors.productionOrder && <small className="text-red-500">{errors.productionOrder.message}</small>}
      </form>
      <div className="space-y-6">
        {order && <div className="flex gap-3 p-4 bg-white rounded shadow">
          <img src={brandLogoUrl} alt="brand" className="flex-none object-contain h-32 px-3" />
          <div className="flex-grow ">
            <OrderHeader order={order} />
          </div>
        </div>}
        {operations.length > 0 && <p className="underline ">เลือก Work Center ที่ต้องการตรวจสอบ</p>}
        <div className='grid w-full grid-cols-1 gap-3 md:grid-cols-2 '>
          {operations.map((operation) => (
            <button key={operation.id}
              className={` p-2 px-3 text-left rounded-md border${selectedOperation?.operationNo === operation.operationNo ? ' bg-blue-100 border-blue-600':''}`}
              onClick={() => {
                setSelectedOperation(operation)
                setShowFgInspectForm(true)
              }}>
                <div className="flex items-center gap-1 break-words">
                  {operation.actualWorkCenterId ? 
                  <h6 className={`${selectedOperation?.operationNo === operation.operationNo ? 'text-blue-600':''}`}>{operation.operationNo} - {operation.actualWorkCenterDescription} ({operation.actualWorkCenterId})</h6> : 
                  <h6 className={`${selectedOperation?.operationNo === operation.operationNo ? 'text-blue-600':''}`}>{operation.operationNo} - {operation.workCenterDescription} ({operation.workCenterId})</h6>}
                </div>
            </button>
          ))}
        </div>
      </div>
      {showFgInspectForm && order && selectedOperation && 
      <FGInspection
        show={showFgInspectForm}
        onHide={() => {
          setSelectedOperation(undefined)
          setShowFgInspectForm(false)
        }}
        productionOrder={order}
        operation={selectedOperation!}
        fgInspectionLogs={fgInspectionLogs}
        mutate={mutate}
      />}
    </PageContainer>
  )
}